<template>
    <div>
        <div>
            <!--
            <input type="button" value="EMAP16" @click="openLayers.Layer.Tile.Value = 'EMAP16'" />
            <input type="button" value="PHOTO2" @click="openLayers.Layer.Tile.Value = 'PHOTO2'" />
            <input type="button" value="EMAP9" @click="openLayers.Layer.Tile.Value = 'EMAP9'" />
            -->

            <!--
            <input type="button" value="雷達回波" @click="switchLayer(openLayers.Layer.Radar,true)" />
            <input type="button" value="雨量觀測-日累積圖" @click="switchLayer(openLayers.Layer.Rain,true)" />
            <input type="button" value="即時24小時累積雨量整合雷達回波估計圖" @click="switchLayer(openLayers.Layer.Raingauge,true)" />
            -->
            <input type="button" value="行政區" @click="switchLayer(openLayers.Layer.CropAlert,true)" />
                
            
            <!--
            <input type="button" value="zoomIn" @click="zoomIn()" />
            <input type="button" value="zoomOut" @click="zoomOut()" />
            -->

        </div>
        <div id="map"></div>  
    </div>
    
</template>
<script>

import Map from 'ol/Map';
import View from 'ol/View';
import { XYZ, 
         Vector as VectorSource, 
         ImageStatic as Static 
        } from "ol/source";
import { fromLonLat, transformExtent } from "ol/proj";
import { Tile,
         Vector as VectorLayer,
         Image as ImageLayer, 
        } from "ol/layer";
import KML from "ol/format/KML";
import GeoJSON from "ol/format/GeoJSON";
import { Fill, Stroke, Style } from "ol/style";

    export default {
        data() {
            return {

                openLayers:{
                    //地圖物件
                    Map:null,
                    //目前地圖的視野
                    Zoom:10,
                    //地圖最大視野
                    ZoomMax:15,
                    //地圖最小視野
                    ZoomMin:5,
                    //行政區和大區之間切換的視野
                    ZoomChange:11,
                    //地圖預設值
                    Default:
                    {
                        //容器的ID
                        Target:'map',
                        //緯度
                        CenterLat:22.6189343,
                        //經度
                        CenterLon:120.2675308,
                        //視野(Zoom)
                        Zoom:10,
                    },
                    //相關圖層
                    Layer:{
                        //底圖
                        Tile:{
                            //目前選擇的底圖
                            Value:"EMAP16",
                            //臺灣通用電子地圖(不含等高線及門牌)
                            EMAP16:null,
                            //正射影像圖(通用)
                            PHOTO2:null,
                            //臺灣通用電子地圖(無鐵公路)
                            EMAP9:null
                        },
                        //雷達回波
                        Radar:null,
                        //雨量觀測-日累積圖
                        Rain:null,
                        //即時24小時累積雨量整合雷達回波估計圖
                        Raingauge:null,

                        //作物預警
                        CropAlert:null,
                    },
                    //相關圖層(當下選擇)
                    Choose:{

                        //作物預警
                        CropAlert:""
                    },
                    //相關圖層(樣式)
                    Style:{

                        //作物預警
                        CropAlert:function(aFeature){

                            console.log("CropAlert");

                            if(aFeature.values_.Town_ID == window.vue.openLayers.Choose.CropAlert){

                                return new Style({
            
                                    //區塊外框線
                                    stroke: new Stroke({
                                    //外框線顏色
                                    color: "#FF0000",
                                    //外框線寬度
                                    width: 2
                                    }),

                                    //區塊樣式
                                    fill: new Fill({
                                    color: "rgba(0, 0, 0, 0)",
                                    }),
                                            
                                    //為了讓選擇的圖示，別被其他圖示蓋過，所以zIndex加大
                                    zIndex: 11001,   //備註 zIndex 越大會越上層
                                });

                            }else{

                                return new Style({
            
                                    //區塊外框線
                                    stroke: new Stroke({
                                    //外框線顏色
                                    color: "#000000",
                                    //外框線寬度
                                    width: 2
                                    }),

                                    //區塊樣式
                                    fill: new Fill({
                                    color: "rgba(0, 0, 0, 0)",
                                    }),
                                            
                                    //為了讓選擇的圖示，別被其他圖示蓋過，所以zIndex加大
                                    zIndex: 11000,   //備註 zIndex 越大會越上層
                                });

                            }
                        },
                    },
                }
                
            }
        },
        watch: {

            //圖層-底圖(選擇)
            "openLayers.Layer.Tile.Value":function(val) 
            {  
                this.hideAllBaseLayer();

                switch (val)
                {
                    case "EMAP16":
                    this.openLayers.Layer.Tile.EMAP16.setVisible(true);
                    break;
                    case "PHOTO2":
                    this.openLayers.Layer.Tile.PHOTO2.setVisible(true);
                    break;
                    case "EMAP9": 
                    this.openLayers.Layer.Tile.EMAP9.setVisible(true);
                    break;   
                    default: 
                }    
            },
        },
        mounted(){

            this.initBaseLayer();
            this.initMap();
        },
        created() {
            window.vue = this;  //在created方法中，將變數全局化，主控台可用 window.vue._data 調閱或呼叫(若不用可以直接遮罩)
                                //例如:window.vue._data.map.getCesiumScene().setEnabled(false);
        },
        destroyed() {

        },
        methods: {

            // 初始(底圖)
            initBaseLayer:function(){

                const _this = this;

                this.openLayers.Layer.Tile.EMAP16 = new Tile({
                    //maxZoom: 21,
                    source: new XYZ({
                        url: "http://wmts.nlsc.gov.tw/wmts/EMAP16/default/EPSG:3857/{z}/{y}/{x}"
                    }),
                });

                this.openLayers.Layer.Tile.PHOTO2 = new Tile({
                    //maxZoom: 21,
                    source: new XYZ({
                        url: "http://wmts.nlsc.gov.tw/wmts/PHOTO2/default/EPSG:3857/{z}/{y}/{x}"
                    }),
                });

                this.openLayers.Layer.Tile.EMAP9 = new Tile({
                    //maxZoom: 21,
                    source: new XYZ({
                        url: "http://wmts.nlsc.gov.tw/wmts/EMAP9/default/EPSG:3857/{z}/{y}/{x}"
                    }),
                });


                // 雷達回波 
                this.openLayers.Layer.Radar = new ImageLayer({   
                    visible: true,
                    source: new Static({
                        url: "WeatherLayers/HDMOS/HDMOS.radar.png",
                        imageExtent: transformExtent(
                        [115.0, 19.2, 129.22, 27.2],
                        "EPSG:4326",
                        "EPSG:3857"
                        ),
                    }),
                });

                // 雨量觀測-日累積圖
                this.openLayers.Layer.Rain = new ImageLayer({  
                    visible: true,
                    source: new Static({
                        url: "WeatherLayers/O-A0040-003/O-A0040-003/0/0/0.png",
                        imageExtent: transformExtent(
                        [119.188024, 21.523313, 123.578233, 25.918078],
                        "EPSG:4326",
                        "EPSG:3857"
                        ),
                    }),
                });

                // 即時24小時累積雨量整合雷達回波估計圖
                this.openLayers.Layer.Raingauge = new VectorLayer({ 
                    visible: true,
                    source: new VectorSource({
                        url: "WeatherLayers/raingauge_kridmap/kridmap/base.kml",
                        format: new KML(),
                    }),
                });

                // 作物預警(雲林行政區)
                this.openLayers.Layer.CropAlert  = this.getStandardVectorPlane({

                    style: this.openLayers.Style.CropAlert,
                    source_url: "GeoJSON/yunlin.geojson",
                    //source_projection:"EPSG:3826",
                    onLoad:function(Param){

                        var mResponseText = Param.XMLHttpRequest.responseText;
                        //若坐標系是TWD97請用這個
                        //var mFeatures = (new GeoJSON()).readFeatures(mResponseText);
                        
                        //若坐標系是經緯度請用這個
                        var mFeatures = (new GeoJSON()).readFeatures(mResponseText,{ featureProjection: Param.Projection });  
                        _this.openLayers.Layer.CropAlert.getSource().addFeatures(mFeatures);
                    }
                });
                this.openLayers.Layer.CropAlert.set("LayerId", "CropAlert");

            },

            // 隱藏所有(底圖)
            hideAllBaseLayer:function(){

                this.openLayers.Layer.Tile.EMAP16.setVisible(false);
                this.openLayers.Layer.Tile.PHOTO2.setVisible(false);
                this.openLayers.Layer.Tile.EMAP9.setVisible(false);
            },

            //初始地圖
            initMap: function () { 
                
                const _this = this;

                this.openLayers.Map = new Map({
                    target: _this.openLayers.Default.Target,
                    //把預設的地圖控制項清空
                    controls:[],
                    //底圖
                    layers: [
                        _this.openLayers.Layer.Tile.EMAP16,
                        _this.openLayers.Layer.Tile.PHOTO2,
                        _this.openLayers.Layer.Tile.EMAP9
                    ],
                    view: new View({
                        maxZoom: _this.openLayers.ZoomMax,
                        minZoom: _this.openLayers.ZoomMin,
                        center: fromLonLat([_this.openLayers.Default.CenterLon, _this.openLayers.Default.CenterLat]),
                        zoom: _this.openLayers.Default.Zoom
                    })
                });

                //當地圖點擊觸發
                this.openLayers.Map.on('click', function (e) {

                    var pixel = e.pixel;
                    var click_event = [];

                    //取得所以被觸發的圖層，並將它堆疊再一起
                    _this.openLayers.Map.forEachFeatureAtPixel(pixel, function(feature, layer) 
                    {
                        click_event.push({feature:feature,layer:layer});
                    });

                    if(click_event.length > 0) 
                    {
                        //僅取第一個被觸發的圖層
                        var mLayer = click_event[0].layer;
                        var mFeature = click_event[0].feature;
                        var mLayerId = mLayer.get("LayerId");
                        
                        switch(mLayerId){

                            //作物預警圖層
                            case 'CropAlert':

                                //當種植面積大於0，點選才做選擇
                                if(mFeature.values_.種植面積_ > 0)
                                {
                                    _this.openLayers.Choose.CropAlert = mFeature.values_.Town_ID;
                                    //因為這版本openLayers 的 getSource().refresh() 會有閃現的情況，目前觀察他是整個會重載GeoJson
                                    //所以改成 getSource().changed(); 僅刷新並不會重載
                                    //_this.openLayers.Layer.CropAlert.getSource().refresh();
                                    _this.openLayers.Layer.CropAlert.getSource().changed();
                                }
                            break;
                            default:
                        }   

                    }

                });

            },

            //切換圖層(state=true 加入地圖、state=false 從地圖移除)
            switchLayer: function(layer,state){

                if(state)
                {
                    this.openLayers.Map.addLayer(layer);
                }
                else
                {
                    this.openLayers.Map.removeLayer(layer);
                }
            },

            //視野向下(放大)
            zoomIn: function(){ this.openLayers.Map.getView().animate({zoom: this.openLayers.Map.getView().getZoom()+1}); },
            //視野向上(縮小)
            zoomOut: function(){ this.openLayers.Map.getView().animate({zoom: this.openLayers.Map.getView().getZoom()-1}); },

            //取得 圖層-面(實例:GeoJSON)
            getStandardVectorPlane:function(option){

              if(option == undefined || option == null){ option = {};  }

              /** 圖層樣式 */
              if(option.style == undefined || option.style == null){ option.style = null;  }
              /** 資料來源網址 */
              if(option.source_url == undefined || option.source_url == null){ option.source_url = "";  }
              /** 資料來源格式 */
              if(option.source_format == undefined || option.source_format == null){ option.source_format = new GeoJSON();  }
              /** 資料投影 */
              if(option.source_projection == undefined || option.source_projection == null){ option.source_projection = "EPSG:4326";  }


              /** 數據加載時 */
              if(option.onLoad == undefined || option.onLoad == null || typeof(option.onLoad) != 'function')
              {
                option.onLoad = function(aXMLHttpRequest){ console.log(aXMLHttpRequest); }
              }
              /** 程序錯誤時 */
              if(option.onError == undefined || option.onError == null || typeof(option.onError) != 'function')
              {
                option.onError = function(){ alert("加載失敗");  }
              }

              var mVector = new VectorLayer({

                style: option.style,
                source: new VectorSource({

                  format: new GeoJSON(),
                  projection: option.source_projection,
                  loader: function (sourceExtent, resolution, projection) {
                    
                    var mXMLHttpRequest = new XMLHttpRequest();
                    mXMLHttpRequest.open('GET', option.source_url);
                    mXMLHttpRequest.onerror = option.onError;
                    mXMLHttpRequest.onload = function () {

                      if (mXMLHttpRequest.status == 200) 
                      {
                        var Param = {

                          XMLHttpRequest:mXMLHttpRequest,
                          SourceExtent:sourceExtent,
                          Resolution:resolution,
                          Projection:projection
                        }

                        option.onLoad(Param);
                      } 
                      else 
                      {
                        option.onError();
                      }
                      
                    }
                    mXMLHttpRequest.send();  

                  }

                })

              });

              return mVector;
            },

        },
    }
</script>
<style scoped>

#map{
    height: 850px;
    width: 100%;
}
</style>